import { Reveal, ChapterTag } from "./motion";
import { useStore } from "../../context/StoreContext";
import { Sofa, BedDouble, Shirt, Car } from "lucide-react";

export const UseCases = () => {
  const { config } = useStore();
  const media = config?.media || {};
  const cases = [
    { icon: Sofa, label: "On the sofa", img: media.use_sofa || media.problem_sofa },
    { icon: BedDouble, label: "On the bed", img: media.use_bed || media.hero_image },
    { icon: Shirt, label: "On your clothes", img: media.use_clothes || media.problem_clothes },
    { icon: Car, label: "In the car", img: media.use_car || media.problem_car },
  ];
  return (
    <section id="usos" data-testid="use-cases-section" className="py-16 sm:py-24 lg:py-32 bg-zinc-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <ChapterTag num="07" label="Uses" />
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-balance">
            One roller. A hair-free life.
          </h2>
        </Reveal>
        <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {cases.map((c, i) => (
            <Reveal key={c.label} delay={i * 0.08}>
              <div data-testid={`use-case-${i}`} className="group relative rounded-2xl overflow-hidden aspect-[3/4] bg-zinc-200">
                {c.img && (
                  <img
                    src={c.img}
                    alt={c.label}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4 flex items-center gap-2 text-white">
                  <c.icon className="w-4 h-4" />
                  <span className="font-display font-semibold text-sm sm:text-base">{c.label}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
